/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_View_Complete_Benefit_CnaInputs */

const en_subscription_view_complete_benefit_cna = /** @type {(inputs: Subscription_View_Complete_Benefit_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all benefits`)
};

const ar_subscription_view_complete_benefit_cna = /** @type {(inputs: Subscription_View_Complete_Benefit_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all benefits`)
};

const de_subscription_view_complete_benefit_cna = /** @type {(inputs: Subscription_View_Complete_Benefit_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all benefits`)
};

const es_subscription_view_complete_benefit_cna = /** @type {(inputs: Subscription_View_Complete_Benefit_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all benefits`)
};

const fr_subscription_view_complete_benefit_cna = /** @type {(inputs: Subscription_View_Complete_Benefit_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all benefits`)
};

const it_subscription_view_complete_benefit_cna = /** @type {(inputs: Subscription_View_Complete_Benefit_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all benefits`)
};

const ja_subscription_view_complete_benefit_cna = /** @type {(inputs: Subscription_View_Complete_Benefit_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all benefits`)
};

const ko_subscription_view_complete_benefit_cna = /** @type {(inputs: Subscription_View_Complete_Benefit_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all benefits`)
};

const pt_br_subscription_view_complete_benefit_cna = /** @type {(inputs: Subscription_View_Complete_Benefit_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all benefits`)
};

const ru_subscription_view_complete_benefit_cna = /** @type {(inputs: Subscription_View_Complete_Benefit_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all benefits`)
};

const th_subscription_view_complete_benefit_cna = /** @type {(inputs: Subscription_View_Complete_Benefit_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all benefits`)
};

const tr_subscription_view_complete_benefit_cna = /** @type {(inputs: Subscription_View_Complete_Benefit_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all benefits`)
};

const zh_cn_subscription_view_complete_benefit_cna = /** @type {(inputs: Subscription_View_Complete_Benefit_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看完整权益`)
};

const zh_tw_subscription_view_complete_benefit_cna = /** @type {(inputs: Subscription_View_Complete_Benefit_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看完整权益`)
};

/**
* | output |
* | --- |
* | "View all benefits" |
*
* @param {Subscription_View_Complete_Benefit_CnaInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_view_complete_benefit_cna = /** @type {((inputs?: Subscription_View_Complete_Benefit_CnaInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_View_Complete_Benefit_CnaInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_view_complete_benefit_cna(inputs)
	if (locale === "ar") return ar_subscription_view_complete_benefit_cna(inputs)
	if (locale === "de") return de_subscription_view_complete_benefit_cna(inputs)
	if (locale === "es") return es_subscription_view_complete_benefit_cna(inputs)
	if (locale === "fr") return fr_subscription_view_complete_benefit_cna(inputs)
	if (locale === "it") return it_subscription_view_complete_benefit_cna(inputs)
	if (locale === "ja") return ja_subscription_view_complete_benefit_cna(inputs)
	if (locale === "ko") return ko_subscription_view_complete_benefit_cna(inputs)
	if (locale === "pt_br") return pt_br_subscription_view_complete_benefit_cna(inputs)
	if (locale === "ru") return ru_subscription_view_complete_benefit_cna(inputs)
	if (locale === "th") return th_subscription_view_complete_benefit_cna(inputs)
	if (locale === "tr") return tr_subscription_view_complete_benefit_cna(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_view_complete_benefit_cna(inputs)
	return zh_tw_subscription_view_complete_benefit_cna(inputs)
});